import React, { useMemo, useState } from "react";
import { Reorder } from "framer-motion";
import PersonalInformation from "./PersonalInformation";
import DemographicsSection from "./DemographicsSection";
import LifestyleSection from "./LifestyleSection";
import HealthInformationSection from "./HealthInformationSection";
import PhoneNumbersSection from "./PhoneNumbersSection";
import EmailAddressesSection from "./EmailAddressesSection";
import StudyEnrollmentSection from "./StudyEnrollmentSection";
import RecruitmentSourceSection from "./RecruitmentSourceSection";
import MedicalSection from "./MedicalSection";
import WorkflowsSection from "./WorkflowsSection";
import NotesSection from "./NotesSection";
import EngagementSection from "./EngagementSection";
import TabSection from "./TabSection";
import SectionDivider from "./SectionDivider";
import DealsSection from "./DealsSection";

/* SECTION MAP */
const SECTION_COMPONENTS = {
  personal: PersonalInformation,
  demo: DemographicsSection,
  life: LifestyleSection,
  health: HealthInformationSection,
  phone: PhoneNumbersSection,
  email: EmailAddressesSection,
};

const DEFAULT_ORDER = ["personal", "demo", "life", "health", "phone", "email"];


const SubjectSections = ({ id, model, changeModel, isCreate, form }) => {
  const [orderedSections, setOrderedSections] = useState(DEFAULT_ORDER);


  const activeForm = useMemo(() => {
    if (form) return form;

    // Fallback for Legacy View (Old Code compatibility)
    return {
      model,
      setValue: ({ key, value }) => {
        changeModel.current[key] = Array.isArray(value)
          ? value
          : {
            ...(changeModel.current[key] || {}),
            ...value,
          };
      },

    };
  }, [form, model, changeModel]);

  /* LEFT COLUMN (DRAGGABLE) */
  const leftColumn = useMemo(
    () => (
      <Reorder.Group
        axis="y"
        values={orderedSections}
        onReorder={setOrderedSections}
        style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}
      >
        {orderedSections.map((key) => {
          const Component = SECTION_COMPONENTS[key];
          if (!Component) return null;

          return (
            <Reorder.Item key={key} value={key} style={{ listStyle: "none" }}>
              <Component subjectId={id} form={isCreate ? activeForm : undefined} />
              <SectionDivider width="380px" />
            </Reorder.Item>
          );
        })}
      </Reorder.Group>
    ),
    [orderedSections, id, isCreate, activeForm]
  );

  /* RENDER */
  return (
    <div className="row mt-3 gx-2">
      {/* LEFT */}
      <div className="col-4">{leftColumn}</div>

      {/* CENTER */}
      <div
        className="col-4 container-fluid"
        style={{ backgroundColor: "#efeef5" }}
      >

        <StudyEnrollmentSection
          subjectId={id}
          form={activeForm}
        />

        <SectionDivider width="380px" />


        <RecruitmentSourceSection
          subjectId={id}
          form={activeForm}
        />
        <SectionDivider width="380px" />
        <DealsSection
          subjectId={id}
          form={activeForm}
        />

        {!isCreate && <TabSection subject={model} subjectId={id} />}
      </div>

      {/* RIGHT */}
      <div className="col-4 ">
        <MedicalSection subjectId={id} form={isCreate ? activeForm : undefined} />
        <SectionDivider width="380px" />

        {!isCreate && (
          <>
            <WorkflowsSection subjectId={id} />
            <SectionDivider width="380px" />
          </>
        )}

        <NotesSection subjectId={id} form={isCreate ? activeForm : undefined} />
        <SectionDivider width="380px" />

        {!isCreate && (
          <>
            <EngagementSection subjectId={id} />
            <SectionDivider width="380px" />
          </>
        )}
      </div>
    </div>
  );
};

export default SubjectSections;